
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./', true, /\.js$/)
const serverObj = {}

modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    if (moduleName === 'index') {
        return
    }
    const value = modulesFiles(modulePath)
    serverObj[moduleName] = value.default
}, {})


export default serverObj